import { Redirect } from 'expo-router';

export default function Index(): React.ReactNode {
  return <Redirect href="/(auth)/login" />;
}
